import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6572cdf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TemplatesListFilters__inputs" }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "TemplatesListFilters bg-white border px-4 py-2",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_input, {
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
        placeholder: "Наименование шаблона"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        placeholder: "Кто добавил",
        loading: _ctx.data_state.users.is_loading,
        failed: _ctx.data_state.users.is_failed,
        "error-text": "При получении списка произошла ошибка",
        options: _ctx.data_state.users.list,
        value: _ctx.state.user_id,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.user_id) = $event)),
        onRefresh: _ctx.loadUsers,
        onLoadmore: _ctx.loadMoreUsers,
        class: "mt-2"
      }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onLoadmore"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата создания от",
        value: _ctx.state.from_created_at,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.from_created_at) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата создания до",
        value: _ctx.state.to_created_at,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.to_created_at) = $event))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        class: "second text small mt-2",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small mt-2",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}